export default __webpack_public_path__ + "static/media/ForSm.808c5be7.jpg";